import { useShipLedger } from '../../hooks/useShipLedger'
import { useShipVendorPhones } from '../../hooks/useShipVendorPhones'
import { InfoBanner } from '../InfoBanner'
import { SHIP_TEXT } from '../../constants/ship.logic'
import { Button } from '@indipia/ui-core'
// 오류줄 · 자재파트너 조회 실패 · 미저장 변경 · 선택 삭제 바

export type GanttNoticeStripsProps = {
  dragError: string
  showVendor: boolean
  sigOn: boolean
  ledgerQ: ReturnType<typeof useShipLedger>
  phonesQ: ReturnType<typeof useShipVendorPhones>
  hasPending: boolean
  pendingChanges: Map<number, { startDate: string; endDate: string; }>
  handleCancel: () => void
  saving: boolean
  handleSave: () => Promise<void>
  selectedTaskIds: Set<number>
  setSelectedTaskIds: React.Dispatch<React.SetStateAction<Set<number>>>
  handleDeleteSelected: () => Promise<void>
}

export function GanttNoticeStrips({
  dragError, showVendor, sigOn, ledgerQ, phonesQ, hasPending, pendingChanges, handleCancel, saving,
  handleSave, selectedTaskIds, setSelectedTaskIds, handleDeleteSelected,
}: GanttNoticeStripsProps) {
  return (
    <>
      {/* 드래그 에러 토스트 */}
      {dragError && (
        <div style={{ background: 'var(--color-errorSubtle)', borderBottom: 'var(--border-width-hairline) solid color-mix(in srgb, var(--color-error) 25%, var(--shell-surface))', padding: '7px 18px', display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="var(--color-error)" strokeWidth="2" strokeLinecap="round">
            <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
          </svg>
          <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--status-danger-600)' }}>{dragError}</span>
        </div>
      )}

      {/* 자재파트너 정보(원장·전화) 조회 실패 — 라벨은 그리지 않고 안내 + 다시 시도 */}
      {showVendor && !sigOn && (ledgerQ.isError || phonesQ.isError) && (
        <div style={{ padding: '8px 18px 0', flexShrink: 0 }}>
          <InfoBanner>
            {SHIP_TEXT.vendorLoadFailed}{' '}
            <Button variant="secondary" size="sm" onClick={() => { void ledgerQ.refetch(); void phonesQ.refetch() }}>{SHIP_TEXT.retry}</Button>
          </InfoBanner>
        </div>
      )}

      {/* 미저장 변경 알림 */}
      {hasPending && (
        <div style={{ background: 'var(--gt-subtle)', borderBottom: 'var(--border-width-hairline) solid color-mix(in srgb, var(--gt-primary) 25%, var(--shell-surface))', padding: '8px 18px', display: 'flex', alignItems: 'center', gap: 10, flexShrink: 0 }}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--gt-primary)" strokeWidth="2" strokeLinecap="round">
            <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
          </svg>
          <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--gt-primary)', flex: 1 }}>
            {pendingChanges.size}개 공종의 날짜가 변경되었습니다. 저장하시겠습니까?
          </span>
          <Button variant="secondary" size="sm" onClick={handleCancel}>
            취소
          </Button>
          <Button variant="primary" size="sm" loading={saving} onClick={handleSave}>
            {saving ? '저장 중...' : '저장'}
          </Button>
        </div>
      )}

      {/* 선택 삭제 바 */}
      {selectedTaskIds.size > 0 && (
        <div style={{ background: 'var(--color-errorSubtle)', borderBottom: 'var(--border-width-hairline) solid color-mix(in srgb, var(--color-error) 25%, var(--shell-surface))', padding: '8px 18px', display: 'flex', alignItems: 'center', gap: 10, flexShrink: 0 }}>
          <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--status-danger-600)', flex: 1 }}>{selectedTaskIds.size}개 공종 선택됨</span>
          <Button variant="secondary" size="sm" onClick={() => setSelectedTaskIds(new Set())}>선택 해제</Button>
          <Button variant="danger" size="sm" onClick={handleDeleteSelected}>선택 삭제</Button>
        </div>
      )}
    </>
  )
}
